module.exports = __webpack_public_path__ + "img/h6.f723f3ff.png";